import { DataTableNew } from "@/components/shared/DataTable";
import { useMemo } from "react";
import { UserService } from "@/services/userService";
import { formatDate } from "@/utils/dateUtils";
import StatusBadge from "@/components/shared/StatusBadge";

// Routing to the correct tenant's DB is handled entirely by the backend
// (get_tenant_db_from_jwt_with_query_scope) — when SuperAdmin sends
// ?tenantId=<x> the session is opened against that tenant's engine
// (shared platform or dedicated DB). No X-Tenant-Slug header hack
// needed from the frontend.
const UsersPanel = ({ tenantId }) => {
    const COLUMNS = useMemo(
        () => [
            {
                key: "name",
                label: "Name",
                sortable: false,
                render: (val) => <span className="font-medium text-[13px] text-text-primary">{val ?? "—"}</span>,
            },
            {
                key: "email",
                label: "Email",
                sortable: false,
                render: (val) => <span className="text-text-primary text-[12px]">{val ?? "—"}</span>,
            },
            {
                key: "role",
                label: "Role",
                sortable: false,
                render: (val, row) => <span className="text-text-primary text-[12px]">
                    {row.isSuperAdmin ? "SuperAdmin" : val ? val.name || "—" : "—"}
                </span>,
            },
            {
                key: "isActive",
                label: "Status",
                sortable: false,
                align: "center",
                render: (_val, row) => (
                    <StatusBadge isActive={row?.isActive} isDeleted={row?.isDeleted} />
                ),
            },
            {
                key: "createdAt",
                label: "Created At",
                sortable: false,
                render: (val) => <span className="text-text-primary text-[12px]">{val ? formatDate(val) : "—"}</span>,
            },
        ],
        [],
    );

    // The table alone. The card-and-header wrapper this used to sit in was a
    // second panel inside the tenant-details card, under a heading that only
    // repeated the "Users" tab the reader had just clicked.
    return (
        <DataTableNew
            key="users-table"
            className="overflow-hidden rounded-xl border border-border-primary"
            columns={COLUMNS}
            showPagination={true}
            sortable={false}
            api={UserService.fetchUsersList}
            extraParams={{ tenantId }}
            dataPath="users"
        />
    );
};

export default UsersPanel